import { helper } from '@ember/component/helper';

export default helper(function containsHelper([ haystack, ...needles ]) {
  if (!haystack || !needles.length) {
    return false;
  }
  if (typeof haystack !== 'string') {
    haystack = '' + haystack;
  }
  return needles.some(needle => haystack.includes(needle));
});
